export const ChipComboBox = 'atlantis-chip-combo-box';